import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { memo, useEffect, useMemo, useRef, useState } from "react";
import { Box, Link, Font, useMatchMedia, PageContainer, LogoSimple, PinBubbleDefaultMapIcon, QuestionSignIcon, CircleUserIcon, BoltStyle1ActiveNatureIcon, useSsr, createPochtaTheme, mergeCreateThemeConfigs } from "@pochta/ui";
import { portalTheme, createPortalThemeConfig } from "@pochta/ui/themes/portal";
import { MenuUser, MenuUserItem } from "@pochta/header";
import GlobalThemeV2 from "../../../GlobalThemeV2";
import { ThemeProvider } from "styled-components";
import refreshToken from "../../../../api/refreshToken";
import formatPrice from "../../../../helpers/formatPrice";
import isActiveUrl from "../../../../helpers/isActiveUrl";
import { Menu } from "./components/Menu";
import Submenu from "./components/Submenu";
import HeaderLink from "./components/HeaderLink";
import Hamburger from "./components/mobile/Hamburger";
import MobileMenu from "./components/mobile/MobileMenu";
import storeUserData from "../../../../helpers/storeUserData";
import { NOT_FOUND, SESSION_CHECK_TIME } from "./constants";
import { HeaderBox, HeaderTab, IconWrapper, IconBoltWrapper, IconMobileBoltWrapper, UserNameContainer, HeaderTop, HeaderTopInner, BorderedBox, ServiceMenuTarget } from "./Header.styles";

var Header = function Header(_ref) {
  var _menu$menuActive;

  var _ref$modernColors = _ref.modernColors,
      modernColors = _ref$modernColors === void 0 ? true : _ref$modernColors,
      _ref$modernFonts = _ref.modernFonts,
      modernFonts = _ref$modernFonts === void 0 ? true : _ref$modernFonts,
      _ref$isFluid = _ref.isFluid,
      isFluid = _ref$isFluid === void 0 ? false : _ref$isFluid,
      pageContainerMaxWidth = _ref.pageContainerMaxWidth,
      background = _ref.background,
      serviceMenu = _ref.serviceMenu,
      _ref$menu = _ref.menu,
      menu = _ref$menu === void 0 ? [] : _ref$menu,
      _ref$authorized = _ref.authorized,
      authorized = _ref$authorized === void 0 ? false : _ref$authorized,
      userName = _ref.userName,
      trackedItems = _ref.trackedItems,
      bonusAccount = _ref.bonusAccount,
      postIdLogoutUrl = _ref.postIdLogoutUrl,
      postIdUserAccountUrl = _ref.postIdUserAccountUrl,
      postIdLoginUrl = _ref.postIdLoginUrl,
      postIdUserBonusHistoryUrl = _ref.postIdUserBonusHistoryUrl,
      postIdUserEmail = _ref.postIdUserEmail,
      refreshTokenUrl = _ref.refreshTokenUrl,
      userId = _ref.userId,
      userPhone = _ref.userPhone,
      _ref$topAlerts = _ref.topAlerts,
      topAlerts = _ref$topAlerts === void 0 ? null : _ref$topAlerts,
      onClickPostIdLogin = _ref.onClickPostIdLogin,
      onClickSettings = _ref.onClickSettings,
      onClickLogout = _ref.onClickLogout,
      _ref$logoUrl = _ref.logoUrl,
      logoUrl = _ref$logoUrl === void 0 ? "//pochta.ru/" : _ref$logoUrl,
      _ref$officesUrl = _ref.officesUrl,
      officesUrl = _ref$officesUrl === void 0 ? "//pochta.ru/offices" : _ref$officesUrl,
      _ref$supportUrl = _ref.supportUrl,
      supportUrl = _ref$supportUrl === void 0 ? "//pochta.ru/support" : _ref$supportUrl,
      _ref$trackingUrl = _ref.trackingUrl,
      trackingUrl = _ref$trackingUrl === void 0 ? "//pochta.ru/tracking" : _ref$trackingUrl,
      _ref$trackingBadgeUrl = _ref.trackingBadgeUrl,
      trackingBadgeUrl = _ref$trackingBadgeUrl === void 0 ? trackingUrl : _ref$trackingBadgeUrl,
      _ref$aboutUrl = _ref.aboutUrl,
      aboutUrl = _ref$aboutUrl === void 0 ? "//pochta.ru/mission-and-strategy" : _ref$aboutUrl,
      _ref$newsUrl = _ref.newsUrl,
      newsUrl = _ref$newsUrl === void 0 ? "//pochta.ru/news-list" : _ref$newsUrl,
      _ref$vacancyUrl = _ref.vacancyUrl,
      vacancyUrl = _ref$vacancyUrl === void 0 ? "//pochta.ru/vacancy-list" : _ref$vacancyUrl,
      mobileMenu = _ref.mobileMenu;

  var _useSsr = useSsr(),
      isSsr = _useSsr.isSsr;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      menuActive = _useState2[0],
      setMenuActive = _useState2[1];

  var _useState3 = useState(NOT_FOUND),
      _useState4 = _slicedToArray(_useState3, 2),
      submenuActive = _useState4[0],
      setSubmenuActive = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      menuItems = _useState6[0],
      setMenuItems = _useState6[1];

  var notDesktop = useMatchMedia("notDesktop");

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isOpen = _useState8[0],
      setIsOpen = _useState8[1];

  var timerSessionRef = useRef();
  var themeRef = useRef(portalTheme);
  var anchorRef = useRef(null);
  var currentIndexItem = useMemo(function () {
    if (isSsr) return 0;
    return menu.map(function (_ref2, index) {
      var subItems1 = _ref2.items;
      return subItems1.map(function (_ref3) {
        var subItems2 = _ref3.items,
            link = _ref3.link;
        return ((subItems2 === null || subItems2 === void 0 ? void 0 : subItems2.length) > 0 ? subItems2.find(function (item) {
          return isActiveUrl(item.link);
        }) : isActiveUrl(link)) && index;
      });
    }).findIndex(function (elements) {
      return elements.filter(Boolean).length > 0;
    });
  }, [menu, isSsr]);
  useEffect(function () {
    if (postIdUserEmail && userPhone && userId) {
      storeUserData(postIdUserEmail, userPhone, userId);
    }
  }, [postIdUserEmail, userPhone, userId]);
  useEffect(function () {
    if (currentIndexItem > -1) {
      setMenuActive(currentIndexItem);
    }
  }, [currentIndexItem]);
  var showBonusBalance = ["CONFIRMED_MEMBER", "NOT_CONFIRMED_MEMBER"].includes(bonusAccount === null || bonusAccount === void 0 ? void 0 : bonusAccount.memberStatus);
  var showTrackingItems = !!+trackedItems;

  var tabHandler = function tabHandler(tab) {
    return function (event) {
      event.preventDefault();
      setMenuActive(tab);
    };
  };

  var hamburgerHandlerOpen = function hamburgerHandlerOpen() {
    setIsOpen(true);
  };

  var hamburgerHandlerClose = function hamburgerHandlerClose() {
    setIsOpen(false);
  };

  useEffect(function () {
    timerSessionRef.current = setInterval(function () {
      refreshToken(refreshTokenUrl).catch(function () {});
    }, SESSION_CHECK_TIME);
    return function () {
      clearInterval(timerSessionRef.current);
    };
  }, [authorized, refreshTokenUrl]);
  useEffect(function () {
    if (!modernColors) {
      themeRef.current = createPochtaTheme(mergeCreateThemeConfigs(createPortalThemeConfig, {
        color: {
          importance: {
            primary: {
              base: function base(_ref4) {
                var palette = _ref4.palette;
                return palette.baseBlue.hex50;
              }
            }
          },
          text: {
            link: {
              base: function base(_ref5) {
                var palette = _ref5.palette;
                return palette.baseBlue.hex50;
              },
              hover: function hover(_ref6) {
                var palette = _ref6.palette;
                return palette.baseOrange.hex50;
              }
            }
          }
        }
      }));
    }
  }, [modernColors]);
  useEffect(function () {
    var trackHandler = function trackHandler(event) {
      var isSubmenu = !!event.target.closest("[data-submenu='submenu']");

      if (!isSubmenu) {
        setSubmenuActive(NOT_FOUND);
      }
    };

    window.removeEventListener("mouseover", trackHandler);

    if (submenuActive !== NOT_FOUND) {
      window.addEventListener("mouseover", trackHandler);
    }

    return function () {
      window.removeEventListener("mouseover", trackHandler);
    };
  }, [submenuActive]);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeRef.current
  }, /*#__PURE__*/React.createElement(HeaderBox, {
    modernFonts: modernFonts,
    bg: background || "palette.neutralsWhite.hex100"
  }, modernFonts && /*#__PURE__*/React.createElement(GlobalThemeV2, null), topAlerts, /*#__PURE__*/React.createElement(BorderedBox, null, /*#__PURE__*/React.createElement(PageContainer, {
    fluid: isFluid,
    limitMaxWidthBreakpoint: pageContainerMaxWidth
  }, /*#__PURE__*/React.createElement(HeaderTop, {
    notDesktop: notDesktop
  }, /*#__PURE__*/React.createElement(HeaderTopInner, null, /*#__PURE__*/React.createElement(Link, {
    href: "#main-content",
    style: {
      opacity: 0
    },
    "aria-label": "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C\u0443 \u043A\u043E\u043D\u0442\u0435\u043D\u0442\u0443"
  }), /*#__PURE__*/React.createElement(ServiceMenuTarget, {
    id: "service-menu-target",
    flexbox: true,
    mr: 24,
    dangerouslySetInnerHTML: serviceMenu && {
      __html: serviceMenu.mainButtonHtml
    }
  }), /*#__PURE__*/React.createElement(Link, {
    overflow: "hidden",
    href: logoUrl,
    underline: "none",
    title: "\u041F\u043E\u0447\u0442\u0430 \u0420\u043E\u0441\u0441\u0438\u0438"
  }, /*#__PURE__*/React.createElement(LogoSimple, {
    variant: modernColors ? "modern" : "default",
    width: 114,
    height: 16,
    style: {
      display: "block"
    }
  })), /*#__PURE__*/React.createElement(Box, {
    pl: 32,
    display: {
      notDesktop: "none",
      desktop: "flex"
    }
  }, menu === null || menu === void 0 ? void 0 : menu.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Box, {
      pr: 16,
      key: item.title
    }, /*#__PURE__*/React.createElement(HeaderTab, {
      size: "m",
      href: "#",
      onClick: tabHandler(index),
      activeTab: menuActive === index
    }, item.title));
  })), /*#__PURE__*/React.createElement(Box, {
    display: {
      notDesktop: "none",
      desktop: "flex"
    },
    ml: "auto",
    ref: anchorRef,
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    alignItems: "center",
    pr: 28
  }, /*#__PURE__*/React.createElement(IconWrapper, {
    pr: 2,
    modernColors: modernColors
  }, /*#__PURE__*/React.createElement(PinBubbleDefaultMapIcon, {
    size: "s"
  })), /*#__PURE__*/React.createElement(HeaderLink, {
    underline: "none",
    size: "m",
    href: officesUrl
  }, "\u041E\u0442\u0434\u0435\u043B\u0435\u043D\u0438\u044F")), /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    alignItems: "center",
    pr: 28
  }, /*#__PURE__*/React.createElement(IconWrapper, {
    pr: 2,
    modernColors: modernColors
  }, /*#__PURE__*/React.createElement(QuestionSignIcon, {
    size: "s"
  })), /*#__PURE__*/React.createElement(HeaderLink, {
    underline: "none",
    size: "m",
    href: supportUrl
  }, "\u041F\u043E\u043C\u043E\u0449\u044C")), authorized ? /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    alignItems: "center"
  }, showBonusBalance && /*#__PURE__*/React.createElement(Box, {
    mr: 12
  }, /*#__PURE__*/React.createElement(Link, {
    underline: "none",
    href: postIdUserBonusHistoryUrl,
    target: "_blank",
    rel: "noreferrer",
    fontFamily: "inherit"
  }, /*#__PURE__*/React.createElement(Box, {
    flexbox: true
  }, /*#__PURE__*/React.createElement(IconBoltWrapper, {
    modernColors: modernColors
  }, /*#__PURE__*/React.createElement(BoltStyle1ActiveNatureIcon, {
    fontSize: "m",
    color: "importance.primary.base"
  })), /*#__PURE__*/React.createElement(Font, {
    size: "m",
    color: "importance.primary.base",
    "data-testid": "bonus-points-balance"
  }, formatPrice(bonusAccount === null || bonusAccount === void 0 ? void 0 : bonusAccount.bonusPointsBalance, true))))), showTrackingItems && /*#__PURE__*/React.createElement(Box, {
    bg: "importance.primary.base",
    borderRadius: 20,
    mr: 14
  }, /*#__PURE__*/React.createElement(Link, {
    href: trackingBadgeUrl,
    underline: "none",
    fontFamily: "inherit"
  }, /*#__PURE__*/React.createElement(Font, {
    color: "text.white.base",
    size: "s",
    p: "2px 10px",
    "data-testid": "tracking-badge"
  }, trackedItems))), /*#__PURE__*/React.createElement(MenuUser, {
    items: [/*#__PURE__*/React.createElement(MenuUserItem, {
      key: "user-menu-1",
      href: trackingUrl,
      size: "m"
    }, "\u041C\u043E\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F"), /*#__PURE__*/React.createElement(MenuUserItem, {
      key: "user-menu-2",
      href: postIdUserAccountUrl,
      size: "m",
      onClick: onClickSettings
    }, "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438"), /*#__PURE__*/React.createElement(MenuUserItem, {
      key: "user-menu-3",
      href: postIdLogoutUrl,
      onClick: onClickLogout,
      size: "m"
    }, "\u0412\u044B\u0439\u0442\u0438")]
  }, /*#__PURE__*/React.createElement(UserNameContainer, {
    width: 108,
    title: userName,
    "tab-index": "0",
    "aria-label": userName
  }, /*#__PURE__*/React.createElement(Font, {
    size: "m"
  }, userName)))) : /*#__PURE__*/React.createElement(Box, {
    flexbox: true,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(IconWrapper, {
    pr: 2,
    modernColors: modernColors
  }, /*#__PURE__*/React.createElement(CircleUserIcon, {
    size: "s"
  })), /*#__PURE__*/React.createElement(HeaderLink, {
    underline: "none",
    size: "m",
    href: postIdLoginUrl,
    onClick: onClickPostIdLogin,
    ref: anchorRef
  }, "\u0412\u043E\u0439\u0442\u0438"))), /*#__PURE__*/React.createElement(Box, {
    display: {
      notDesktop: "flex",
      desktop: "none"
    },
    ml: "auto",
    alignItems: "center"
  }, showBonusBalance && /*#__PURE__*/React.createElement(Box, {
    mr: 12
  }, /*#__PURE__*/React.createElement(Link, {
    underline: "none",
    href: postIdUserBonusHistoryUrl,
    target: "_blank",
    rel: "noreferrer",
    fontFamily: "inherit"
  }, /*#__PURE__*/React.createElement(Box, {
    flexbox: true
  }, /*#__PURE__*/React.createElement(IconMobileBoltWrapper, null, /*#__PURE__*/React.createElement(BoltStyle1ActiveNatureIcon, {
    fontSize: "m",
    color: "importance.primary.base"
  })), /*#__PURE__*/React.createElement(Font, {
    size: "m",
    color: "importance.primary.base"
  }, formatPrice(bonusAccount.bonusPointsBalance))))), showTrackingItems && /*#__PURE__*/React.createElement(Box, {
    bg: "importance.primary.base",
    borderRadius: 20,
    mr: 14
  }, /*#__PURE__*/React.createElement(Font, {
    color: "text.white.base",
    size: "s",
    p: "2px 10px"
  }, trackedItems)), /*#__PURE__*/React.createElement(Hamburger, {
    onClick: hamburgerHandlerOpen
  })), /*#__PURE__*/React.createElement(MobileMenu, {
    menu: mobileMenu || menu,
    isOpen: isOpen,
    userName: userName,
    authorized: authorized,
    postIdLoginUrl: postIdLoginUrl,
    postIdLogoutUrl: postIdLogoutUrl,
    postIdUserAccountUrl: postIdUserAccountUrl,
    officesUrl: officesUrl,
    supportUrl: supportUrl,
    trackingUrl: trackingUrl,
    aboutUrl: aboutUrl,
    newsUrl: newsUrl,
    vacancyUrl: vacancyUrl,
    onClose: hamburgerHandlerClose,
    onClickPostIdLogin: onClickPostIdLogin,
    onClickSettings: onClickSettings,
    onClickLogout: onClickLogout
  }))))), menu[menuActive] && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Menu, {
    menu: menu[menuActive],
    active: submenuActive,
    onChangeActive: setSubmenuActive,
    setMenuItems: setMenuItems,
    isFluid: isFluid,
    pageContainerMaxWidth: pageContainerMaxWidth,
    "data-testid": "menu"
  }), /*#__PURE__*/React.createElement(Submenu, {
    menu: (_menu$menuActive = menu[menuActive]) === null || _menu$menuActive === void 0 ? void 0 : _menu$menuActive.items[submenuActive],
    parentActive: menuActive,
    active: submenuActive,
    menuItems: menuItems,
    isFluid: isFluid,
    pageContainerMaxWidth: pageContainerMaxWidth,
    "data-testid": "submenu",
    anchorRef: anchorRef.current
  }))), serviceMenu && /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: serviceMenu.menuPanelHtml
    }
  }));
};

export default /*#__PURE__*/memo(Header);